<template>
  <div>
    <v-card v-if="isReady" outlined>
      <v-toolbar class="pl-0" dense flat color="transparant">
        <v-subheader>{{$t("solutionsList")}}</v-subheader>
        <v-spacer></v-spacer>
        <can I="create" a="markers">
          <v-btn
            v-if="marker.markerXSolutions.length > 0 && !readonly"
            color="primary"
            @click="addSolution"
            dark
            small
            icon
          >
            <v-icon>add</v-icon>
          </v-btn>
        </can>
        <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon v-on="on">
              <v-icon>fa-info-circle</v-icon>
            </v-btn>
          </template>
          <v-sheet flat>
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">add</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_solutions_list')}}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
      <swipe-list ref="list" class="card" :items="markerXSolutions" item-key="id">
        <template v-slot="{ item, index}">
          <v-card @dblclick="solutionDetails(item)" class="v-card card-content">
            <v-list-item-title class="pl-5 pt-2">
              <!-- <v-card-title class="py-2"> -->
              <template v-if="$store.state.productSolutions.find(x => x.id == item.solutionId)">
                {{
                `${marker.number}.${index+1} ${$store.state.productSolutions.find(x => x.id == item.solutionId).name}`
                }}
              </template>
              <template v-else>{{$t('chooseSolution')}}</template>
              <!-- </v-card-title> -->
            </v-list-item-title>
            <v-card-actions class="pl-5">
              <v-chip>
                <v-icon
                  :color="item.isApproved === 1 && !item.valid ? 'red' :
                     item.isApproved === 0 && !item.valid ? 'orange':
                      item.isApproved === 2? 'success': 'primary'"
                >{{item.isApproved === 2 ? 'check_circle' : item.isApproved === 1 ? 'priority_high': 'priority_high'}}</v-icon>
                {{item.isApproved == 1 ? $t('broken') : item.isApproved == 2 ? $t('approved') : item.isApproved == 0 ? $t('inProcess') : $t('new') }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click="solutionDetails(item)">{{$t('open')}}</v-btn>
            </v-card-actions>
            <v-divider></v-divider>
          </v-card>
        </template>
        <template
          v-if="$can('delete','markers') && !readonly && !$store.state.isOffline"
          v-slot:right="{ item}"
        >
          <div class="swipeout-action red" title="remove">
            <areyousure
              v-if="!readonly"
              :icon="true"
              color="white"
              v-on:delete="deleteMarkerXSolution(item.id)"
            ></areyousure>
          </div>
        </template>
      </swipe-list>
      <div
        style="height:50px"
        class="d-flex"
        v-ripple
        @click="addSolution"
        :disabled="readonly"
        v-if="marker.markerXSolutions.length == 0"
      >
        <div class="mx-auto my-auto">
          <v-icon color="primary">add_circle_outline</v-icon>
        </div>
      </div>
    </v-card>
  </div>
</template>


<script>
import uuid from "uuid";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import "vue-swipe-actions/dist/vue-swipe-actions.css";

export default {
  name: "markers",
  components: {
    SwipeOut,
    SwipeList
  },
  props: {
    marker: Object,
    blueprint: Object,
    readonly: Boolean
  },
  data() {
    return {
      showDelete: false,
      selected: undefined,
      isReady: false,
      headers: [
        {
          text: this.$t("marker"),
          align: "left",
          value: "number"
        },
        {
          text: this.$t("status"),
          align: "left",
          value: "isApproved"
        },
        { text: "Actions", sortable: false }
      ],
      loading: false,
      markerStatus: 4
    };
  },
  methods: {
    addSolution() {
      let markerXSolution = {
        id: uuid.v4(),
        markerId: this.$route.params.id,
        solutionId: null,
        qrLogAttributeXMarkerXSolutions: [],
        unusedAttributes: [],
        attachments: [],
        new: true,
        dimensionDialog: false,
        attributesDialog: false,
        comments: null
      };
      let arr = [];
      for (let i = 0; i < this.$store.state.allAttributes.length; i++) {
        arr.push({
          id: uuid.v4(),
          markerXSolutionsId: markerXSolution.id,
          qrLogAttribute: this.$store.state.allAttributes[i],
          qrLogAttributeId: this.$store.state.allAttributes[i].id,
          qrLogAttributeListValue: null,
          qrLogAttributeListValueId: null,
          value: null
        });
      }
      markerXSolution.qrLogAttributeXMarkerXSolutions = arr;
      this.$emit("addMarkerXSolution", markerXSolution);
    },
    deleteMarkerXSolution(id) {
      if (this.marker.markerXSolutions.find(x => x.id == id).new) {
        this.marker.markerXSolutions = this.marker.markerXSolutions.filter(
          x => x.id != id
        );
      } else {
        if (this.$store.state.isOffline) {
          let offForm = {
            deleteMarkerXSolution: id
          };
          this.$store.state.offForm.push(offForm);
        } else {
          this.$http
            .deleteMarkerXSolution(id)
            .then(res => {
              this.marker.markerXSolutions = this.marker.markerXSolutions.filter(
                x => x.id != id
              );
              this.$store.commit("updateMarker", this.marker);
              this.$noty.success('<i class="fas fa-check"></i>');
            })
            .catch(err => {
              console.log(err);
              this.$noty.error(this.$t("error"));
            });
        }
      }
    },
    solutionDetails(mxs) {
      this.$emit('open',mxs)
      // this.$router.push({
      //   name: "MarkerXSolutionDetails",
      //   params: {
      //     id: mxs.markerId,
      //     markerXSolutionId: mxs.id,
      //     markerXSolution: mxs,
      //     marker: this.marker,
      //     blueprint: this.blueprint,
      //     readonly: this.readonly
      //   }
      // });
    }
  },
  computed: {
    markerXSolutions() {
      if (this.marker) {
        return this.marker.markerXSolutions;
      }
    }
  },
  watch: {
    marker(n) {}
  },
  created() {
    if (!this.$store.state.isOffline) {
      let requests = [];

      if (this.$store.state.productSolutions == null) {
        requests.push(this.$http.getProductSolutions(true)());
      }

      this.isReady = true;
    } else {
      this.isReady = true;
    }
  }
};
</script>


<style>
a:not(.md-button):hover {
  text-decoration: unset !important;
}
</style>
<style scoped>
.list-installer {
  max-height: 600px;
  overflow-y: auto;
}
</style>

<style scoped>
.swipeout-action {
  display: flex;
  align-items: center;
  padding: 0 3rem;
  cursor: pointer;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Markers/MarkerXSolutions/List.vue